import React from "react";
import styled from "styled-components";
import Button from "sushiweb/Button";
import variables from "../../../constants/assets/variables";
const FilterButton = ({ handleClick, activeFilters = {} }) => {
  return (
    <FilterButtonContainer isFilterPresent={Object.keys(activeFilters).length}>
      {" "}
      <Button
        onClick={() => handleClick("Filter", null)}
        className="sushi-btn"
        appearance="outline"
        data-testid="filterBtnSushi"
        id="filterBtnSushi"
        data-tag={
          Object.keys(activeFilters).length
            ? Object.keys(activeFilters).length
            : undefined
        }
      >
        {" "}
        {Object.keys(activeFilters).length > 0 ? (
          <div className="flex items-center">
            {" "}
            <span>Filters</span>{" "}
          </div>
        ) : (
          "Filters"
        )}{" "}
      </Button>{" "}
    </FilterButtonContainer>
  );
};
const FilterButtonContainer = styled.div`
  &:not(:last-child) {
    margin-right: 10px;
  }
  .sushi-btn {
    position: relative;
    height: 44px;
    &:after {
      width: ${({ isFilterPresent }) => (isFilterPresent ? "24px" : "0px")};
      height: ${({ isFilterPresent }) => (isFilterPresent ? "24px" : "0px")};
      border-radius: 50%;
      position: absolute;
      background-color: ${variables.primaryColor};
      content: attr(data-tag);
      color: #fff;
      text-align: center;
      padding-top: 2px;
      font-weight: 600;
      right: -10px;
      top: -10px;
    }
  }
`;
export default FilterButton;
